'use client';

import { ExtractionMethod } from '@/components';
import { cn } from '@/libs';
import type { HighlightedRaffleDetails } from '@/types/models';

type MainPrize = NonNullable<HighlightedRaffleDetails['mainPrizes']>[0];

type ExtractionMethodWrapperProps = {
  prize: MainPrize;
  drawnSequence?: string[];
  drawDate?: string;
  isFinished?: boolean;
  className?: string;
};

const MATRIX_ROWS = 5;
const MATRIX_COLS = 5;

const toMatrix = (sequence: string[]): string[][] => {
  const matrix: string[][] = [];
  for (let row = 0; row < MATRIX_ROWS; row++) {
    matrix.push(sequence.slice(row * MATRIX_COLS, (row + 1) * MATRIX_COLS));
  }
  return matrix;
};

export const ExtractionMethodWrapper = ({
  prize,
  drawnSequence,
  drawDate,
  isFinished,
  className,
}: ExtractionMethodWrapperProps) => {
  if (!prize.sequenceRule?.length) {
    return null;
  }

  const selectedValues = prize.sequenceRule.map(String);

  const hasFinishedData =
    isFinished === true &&
    drawnSequence?.length === MATRIX_ROWS * MATRIX_COLS &&
    !!prize.winningSequence?.length;

  if (!hasFinishedData) {
    return (
      <div className={cn('mt-4', className)}>
        <ExtractionMethod selectedValues={selectedValues} className="mx-0" />
      </div>
    );
  }

  const isApproximation = prize.drawStatus === 'WINNER_FOUND_APPROXIMATION';

  return (
    <div className={cn('mt-4', className)}>
      <ExtractionMethod
        selectedValues={selectedValues}
        lotteryAwards={toMatrix(drawnSequence!)}
        drawDate={drawDate}
        winningSequence={prize.winningSequence}
        isApproximation={isApproximation}
        className="mx-0"
      />
    </div>
  );
};
